import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "id"];
import styled, { css, keyframes } from 'styled-components';
import { SelectableButton } from 'foundations-components/transitional/components/SelectableButton';
import { jsx as _jsx } from "react/jsx-runtime";
const config = {
  slidePx: 3,
  spacing: 0.05,
  animationDelay: 0.3,
  animationTime: 0.2
};
const translateStart = `transform: translateX(${config.slidePx}px);`;
const translateEnd = `transform: translateX(0);`;
const appear = keyframes(["0%{", " opacity:", ";}100%{", ";opacity:1;visibility:visible;}"], translateStart, 0.4, translateEnd);
const animationCss = ({
  index
}) => css(["animation:", " ", "s cubic-bezier(0.42,0,0.58,1);visibility:hidden;animation-fill-mode:forwards;transition:all;", ""], appear, config.animationTime, index && `animation-delay: ${config.animationDelay + config.spacing * index + 0.01 * Math.pow(index, 1.9)}s;`);
export const AnimatedButtonWrapper = styled.div.withConfig({
  displayName: "ButtonAnimationsstyles__AnimatedButtonWrapper",
  componentId: "wgrm2v-0"
})(["", " border-radius:var(--trellis-border-radius-100,3px);-webkit-font-smoothing:antialiased;> div{height:100%;> div{display:flex;> div{display:flex;align-items:center;width:100%;}}}"], props => {
  if (props.disable) return ``;
  return animationCss;
});
export const AnimatedButton = _ref => {
  let {
      className,
      id
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(AnimatedButtonWrapper, {
      disable: props.disabled,
      className: className,
      id: id,
      children: /*#__PURE__*/_jsx(SelectableButton, Object.assign({}, props))
    })
  );
};